import React, {useState, useEffect} from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import ContactUsTabsContainerData from 'app/Models/Content/ContactUsTabsContainerData';
import ContatUsTabData from 'app/Models/Content/ContatUsTabData';
import {getImageProps, ImageProps} from 'app/utilities/ImageProps';
import ContactUsTab, {ContactUsTabProps} from './ContactUsTab';
import {ContentAreaProperty} from '@episerver/spa-core/Property';
import ContentArea from '@episerver/spa-core/Components/ContentArea';

type ContatUsTabItem = {
  title: string;
  icon: ImageProps;
  main: ContentAreaProperty;
};

const ContactUsTabsContainer = ({data, context}: ComponentProps<ContactUsTabsContainerData>) => {
  const [tabs, setTabs] = useState<ContatUsTabItem[]>(null);
  const [activeTab, setActiveTab] = useState<ContatUsTabItem>(null);

  useEffect(() => {
    const tabs = data.items?.expandedValue?.map(({iconText, iconImage, mainContentArea}: ContatUsTabData) => ({
      title: iconText.value,
      icon: getImageProps(iconImage, context),
      main: mainContentArea,
    }));
    setActiveTab((tabs && tabs[0]) ?? null);
    setTabs(tabs);
  }, [data.items]);

  return (
    <div className='ContactUsTabsContainer'>
      <div className='ContactUsTabsContainer__tabs'>
        {tabs?.map((item, i) => (
          <ContactUsTab key={i} title={item.title} icon={item.icon} active={item === activeTab} onSelect={() => setActiveTab(item)} />
        ))}
      </div>
      {activeTab != null && <ContentArea context={context} data={activeTab.main} />}
    </div>
  );
};

export default ContactUsTabsContainer;
